import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

export default {
  install(app) {
    const page = usePage()

    // Define global computed values
    const user = computed(() => page.props.auth.user)
    const can = computed(() => page.props.can)
    const systemSettings = computed(() => page?.props['system-settings'])
    const breakpoint = computed(() => page.props?.$vuetify?.display)

    const currency = computed(() => {
      let supportedCurrency = Intl.supportedValuesOf('currency')
      let setting = systemSettings.value
      let setCurrency = setting.currency

      if (supportedCurrency.includes(setCurrency)) {
        return setCurrency
      }
      return 'KES'
    })

    // Provide these values globally
    app.provide('$user', user)
    app.provide('$can', can)
    app.provide('$systemSettings', systemSettings)
    app.provide('$breakpoint', breakpoint)
    app.provide('currency', currency)
  }
}
